<ng-container [formGroup]="form">
  <mat-form-field>
    <input
      formControlName="selectedCompany"
      type="text"
      [placeholder]="'components.dtmTab.customElevations.company' | translate"
      required
      matInput
      [matAutocomplete]="auto"
      autocomplete="off"
      [matAutocompleteDisabled]="isCompanyAdmin || isTeamAdmin"
    >
    <mat-autocomplete
      #auto="matAutocomplete"
      (optionSelected)="onCompanyChange($event)"
      [displayWith]="displayCompanyProperty"
    >
      <mat-option
        *ngFor="let company of filteredCompaniesData$ | async"
        [value]="company"
        [disabled]="isAllCompaniesOptionDisable(company.Slug)"
      >
        {{ company.Name }}
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>
</ng-container>


